(function() {
    'use strict';

    webModule.directive('tlLayoutPadding', [function(){
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.addClass('tl-layout-padding');
            }
        };
    }]);

}());
